import { useQuery } from '@tanstack/react-query';
import {
  fetchExecucoesNaoMedidasByContratoIds,
  fetchExecucoesNaoMedidasByContrato,
  type ExecucaoNaoMedidaResumo,
} from '../services/ifDataService';

export type { ExecucaoNaoMedidaResumo };

/** Aggregated for a list of contract IDs (portfolio level) */
export function useIFExecucoesNaoMedidas(contratoIds: string[]) {
  return useQuery({
    queryKey: ['if-exec-nao-medidas', contratoIds],
    queryFn: () => fetchExecucoesNaoMedidasByContratoIds(contratoIds),
    enabled: contratoIds.length > 0,
    staleTime: 5 * 60 * 1000,
  });
}

/** For a single contract */
export function useIFExecucoesNaoMedidasContrato(contratoId: string | null) {
  return useQuery({
    queryKey: ['if-exec-nao-medidas-contrato', contratoId],
    queryFn: () => fetchExecucoesNaoMedidasByContrato(contratoId!),
    enabled: !!contratoId,
    staleTime: 5 * 60 * 1000,
  });
}
